var map = {
	"./ApiKeys": 66,
	"./ApiKeys.coffee": 66,
	"./ApiSandbox": 67,
	"./ApiSandbox.coffee": 67,
	"./ApiUsage": 68,
	"./ApiUsage.coffee": 68,
	"./Neuro": 69,
	"./Neuro.coffee": 69,
	"./api_keys/Modal": 27,
	"./api_keys/Modal.coffee": 27,
	"./api_keys/TableRow": 28,
	"./api_keys/TableRow.coffee": 28,
	"./api_sandbox/CodeHighlighter": 16,
	"./api_sandbox/CodeHighlighter.coffee": 16,
	"./api_sandbox/CopyButton": 17,
	"./api_sandbox/CopyButton.coffee": 17,
	"./api_sandbox/Selector": 6,
	"./api_sandbox/Selector.coffee": 6,
	"./api_sandbox/Textarea": 18,
	"./api_sandbox/Textarea.coffee": 18,
	"./api_usage/Chart": 30,
	"./api_usage/Chart.coffee": 30,
	"./api_usage/Filters": 29,
	"./api_usage/Filters.coffee": 29,
	"./neuro/CallToAction": 50,
	"./neuro/CallToAction.coffee": 50,
	"./neuro/CharacterCounter": 34,
	"./neuro/CharacterCounter.coffee": 34,
	"./neuro/ContentEditable": 37,
	"./neuro/ContentEditable.coffee": 37,
	"./neuro/Feedback": 33,
	"./neuro/Feedback.coffee": 33,
	"./neuro/Footer": 51,
	"./neuro/Footer.coffee": 51,
	"./neuro/LanguageDropdown": 19,
	"./neuro/LanguageDropdown.coffee": 19,
	"./neuro/LanguageSwitchButton": 35,
	"./neuro/LanguageSwitchButton.coffee": 35,
	"./neuro/Marketing": 48,
	"./neuro/Marketing.coffee": 48,
	"./neuro/Modal": 54,
	"./neuro/Modal.coffee": 54,
	"./neuro/Navbar": 31,
	"./neuro/Navbar.coffee": 31,
	"./neuro/SourceA": 36,
	"./neuro/SourceA.coffee": 36,
	"./neuro/SourceB": 38,
	"./neuro/SourceB.coffee": 38,
	"./neuro/Target": 39,
	"./neuro/Target.coffee": 39,
	"./neuro/ToneSelector": 47,
	"./neuro/ToneSelector.coffee": 47,
	"./neuro/WaitingListForm": 13,
	"./neuro/WaitingListForm.coffee": 13,
	"./neuro/footer/LocaleSelector": 52,
	"./neuro/footer/LocaleSelector.coffee": 52,
	"./neuro/helpers/CaretPosition": 60,
	"./neuro/helpers/CaretPosition.coffee": 60,
	"./neuro/helpers/CaretPosition2": 20,
	"./neuro/helpers/CaretPosition2.coffee": 20,
	"./neuro/helpers/Segmenter": 3,
	"./neuro/helpers/Segmenter.coffee": 3,
	"./neuro/helpers/StreamingManagement": 25,
	"./neuro/helpers/StreamingManagement.coffee": 25,
	"./neuro/helpers/js-archives/CaretPosition": 70,
	"./neuro/helpers/js-archives/CaretPosition.js": 70,
	"./neuro/helpers/js-archives/CaretPosition2": 71,
	"./neuro/helpers/js-archives/CaretPosition2.js": 71,
	"./neuro/icons/GlobeIcon": 53,
	"./neuro/icons/GlobeIcon.coffee": 53,
	"./neuro/icons/NeuronIcon": 5,
	"./neuro/icons/NeuronIcon.coffee": 5,
	"./neuro/icons/RobotIcon": 21,
	"./neuro/icons/RobotIcon.coffee": 21,
	"./neuro/logo/NeuroLogo": 11,
	"./neuro/logo/NeuroLogo.coffee": 11,
	"./neuro/marketing/ExampleCard": 15,
	"./neuro/marketing/ExampleCard.coffee": 15,
	"./neuro/marketing/Testimonials": 49,
	"./neuro/marketing/Testimonials.coffee": 49,
	"./neuro/navbar/NavbarSlider": 32,
	"./neuro/navbar/NavbarSlider.coffee": 32,
	"./neuro/panels/AppsPanel": 56,
	"./neuro/panels/AppsPanel.coffee": 56,
	"./neuro/panels/FilesPanel": 55,
	"./neuro/panels/FilesPanel.coffee": 55,
	"./neuro/target/Alternatives": 40,
	"./neuro/target/Alternatives.coffee": 40,
	"./neuro/target/EngineDropdown": 41,
	"./neuro/target/EngineDropdown.coffee": 41,
	"./neuro/target/LimitWarning": 42,
	"./neuro/target/LimitWarning.coffee": 42,
	"./neuro/target/LoadingDots": 12,
	"./neuro/target/LoadingDots.coffee": 12,
	"./neuro/target/TargetCopyButton": 43,
	"./neuro/target/TargetCopyButton.coffee": 43,
	"./neuro/target/TargetSentence": 44,
	"./neuro/target/TargetSentence.coffee": 44,
	"./neuro/target/target_sentence/TargetWord": 45,
	"./neuro/target/target_sentence/TargetWord.coffee": 45,
	"./neuro/target/target_sentence/target_word/WordAlternatives": 46,
	"./neuro/target/target_sentence/target_word/WordAlternatives.coffee": 46,
	"./shared/CopyButton": 10,
	"./shared/CopyButton.coffee": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;